import React from 'react'
import { Button } from '@mui/material'
import { IconSeeker } from '@ui-seeker/core'

import { BIActiveGoal, BIGoalsOpen } from '../@signals'
import BIGoalCards from './GoalCards'
import BIFilledFor from './FilledFor'
import { openGoals } from '../@hooks/useGoals'


/** The first block of the band: the questions, or what the chosen one filled (CU-869fmk5ge piece 1) */
export default function BIGoalsIntro({ goals }) {
	if (BIGoalsOpen.value) return <BIGoalCards goals={goals}/>
	if (BIActiveGoal.value) return <BIFilledFor goals={goals}/>
	return null
}

/** Bottom left of the band, opposite Search (UX Obs. 3): back to the questions, remembered */
export function BIStartFromQuestion() {
	if (BIGoalsOpen.value || BIActiveGoal.value) return null
	return <Button data-tour="bi-start" variant="text" onClick={() => openGoals(true)} startIcon={<IconSeeker icon="compass" sx={{ fontSize: 12 }}/>} sx={{ textTransform: 'none', fontSize: 13, fontWeight: 500 }}>
		Start from a question
	</Button>
}
